export const pt = {
  language: "PT",
  day: "dia",
  search: "Buscar",
  find: "Procurar",
  back: "Anterior",
  next: "Próximo",
  finish: "Concluir",
  selected: "Selecionado",
  selecteds: "Selecionados",
  value: "Valor",
  confirm: "Confirmar",
  cancel: "Cancelar",
  update: "Atualizar",
  editto: "Editar",
  correct: "Corrigir",
  correctErrors: "Corrigir Erros",
  create: "Criar",
  register: "Registrar",
  edit: "Edição",
  delete: "Excluir",
  add: "Adicionar",
  reload: "Recarregar",
  message: "Mensagem",
  save: "Salvar",
  export: "Exportar",
  other: "Outras opções",
  send: "Enviar",
  or: "ou",
  name: "Nome",
  enter: "Entrar",
  start: "Iniciar",
  begin: "Começar",
  gotIt: "Entendi",
  follow: "Seguir",
  following: "Seguindo",
  unfollow: "Desseguir",
  continue: "Continuar",
  share: "Compartilhar",
  include: "Incluir",
  yes: "Sim",
  no: "Não",
  cpf: "CPF",
  months: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  seeMore: "Ver mais",
  deleteUser: "Excluir usuário",
  warningDeleteUser:
    "Este colaborador, seus projetos e bancos de composição serão excluídos permanentemente, removendo todos os acessos a plataforma. Esta ação não poderá ser desfeita.",
  trialRegister: {
    enter: "Entrar",
    freeTrial: "Teste Grátis",
    requestTrial: "SOLICITE SEU PERÍODO DE TESTES",
    meetRubk01:
      "Com o Rubk, você terá acesso à primeira solução orçamentária alinhada com a modelagem BIM do Brasil.",
    meetRubk02:
      "De forma simples e intuitiva, você vai reduzir erros relacionados ao orçamento e vai melhorar o controle de custos da sua empresa. ",
    meetRubk03:
      "Desde a fase inicial, o Rubk orienta com a ajuda de indicadores que servirão de suporte para as tomadas de decisão ao longo do projeto. ",
    meetRubk04:
      "O que está esperando? Preencha o formulário e transforme a sua rotina com o Rubk.  ",
    freeTrialDays: "Teste gratuitamente por 30 dias!",
    privacyPolicy: "Política de Privacidade",
    privacyPolicyMessage:
      "Li e concordo com a %s da Senior, que pode usar as informações aqui fornecidas por mim para entrar em contato comigo, via e-mail, telefone ou whatsapp, para ações de natureza comercial. Posso revogar meu consentimento a qualquer momento enviando um e-mail para lgpd@senior.com.br.*",
    checkYourEmail: "Verifique seu e-mail",
    almostThere01: "Quase lá! Enviamos um e-mail para:",
    almostThere02:
      "Clique no link enviado para seu e-mail para completar sua inscrição.",
    almostThere03: "Caso não encontre, tente verificar sua caixa de spam.",
    almostThere04: "Não encontrou nenhum e-mail?",
    resendEmail: "Reenviar e-mail",
    subscribeNow: "assine o rubk agora",
    subscribeNow02: "assine agora",
    trialEexpiresIn:
      "Sua versão de testes acaba em %s. Assine agora e aproveite ao máximo tudo o que o Rubk tem a oferecer.",
    welcome: {
      engineeringCosts: "ENGENHARIA DE CUSTOS ATÉ 90% MAIS ÁGIL E PRECISA",
      meetRubk:
        "Conheça o Rubk, a primeira solução orçamentária alinhada com a modelagem BIM do Brasil!",
      welcomeToRubk: "Boas-vindas ao Rubk!",
      continue: "Avançar",
    },
    whatToLearn: {
      linkText01: "Importando uma planilha para o Plano de Custo",
      linkText02: "Importando modelos BIM",
      linkText03: "Criando regras de quantitativos",
      linkText04: "Trabalhando com bancos de composição",
      linkText05: "Confira a nossa documentação completa",
      notDisplayMessage: "Não exibir esta mensagem novamente",
      whatLearn: "O que deseja aprender?",
    },
    subcribeCard: {
      cadTitle: "Estamos quase lá!",
      cardTxt01:
        "Com a melhor plataforma orientada a BIM do Brasil, você está elevando o nível de precisão.",
      cardTxt02: "Após confirmar sua assinatura",
      cardTxt03:
        ", nossa equipe de vendas entrará em contato o mais rápido possível, para que você possa desfrutar da melhor experiência que o Rubk tem a oferecer!",
      textBack: "Talvez mais tarde",
      textButton: "Confirmar Inscrição",
      snackText01: "Inscrição confirmada com sucesso.",
      snackText02: "Em breve a nossa equipe entrará em contato.",
    },
  },
  trialExpired: {
    title: "Seu período de teste encerrou!",
    message:
      "Assine o *Rubk* e continue levando agilidade, tecnologia e consistência para todos os seus projetos.",
  },
  trialMessage: {
    title: "Upgrade de conta",
    spaceMessage:
      "Opa! A versão *trial* permite usar até *250 MB* de espaço para importar modelos.",
    spaceMessage2:
      "Faça um upgrade de sua conta e importe um número *ilimitado* de modelos.",
    resourceMessage: "Este recurso está indisponível no plano *trial*.",
    resourceMessage2:
      "Faça um upgrade e aproveite ao máximo os recursos que o *Rubk* tem a oferecer.",
    rememberLater: "Me lembre mais tarde",
    functionalityNotAvailable: "Funcionalidade indisponível no acesso Trial!",
  },
  login: {
    userCreated: "Usuário criado com sucesso",
    isntEmail:
      "O valor inserido não é um e-mail válido. Por favor, insira um e-mail válido.",
    accountExistsDifferent:
      "Conta existe com outra credencial de autenticação.",
    emailAlreadyInUse: "E-mail já encontra-se em uso.",
    passwordLength: "Senha precisa ter ao menos 6 caracteres.",
    wrongPassword: "A combinação de e-mail e senha não é válida.",
    isntCpf:
      "O valor inserido não é um CPF válido. Por favor, insira um CPF válido.",
    reset: "Redefinir",
    resetPassword: "Redefinir senha",
    resetPasswordSuccess: "Senha alterada com sucesso!",
    resendEmail:
      "Por favor, acesse o login e solicite o reenvio da verificação.",
    loginError:
      "Não foi possível efetuar o registro com as informações indicadas.",
    userDisabled: "Usuário desativado.",
    invalidAccessError: "Usuário não tem permissão de acesso.",
    newSessionError: "Uma nova sessão foi aberta com seu usuário.",
    emailError: "Não foi possível verificar seu e-mail.",
    emailSucess: "Seu e-mail foi verificado com sucesso!",
    emailSucessSubmessage: "Tudo pronto para iniciarmos agora.",
    emailSent: "E-mail de recuperação de senha enviado",
    emailNotSent: "E-mail de recuperação de senha não localizado",
    password: "Senha",
    newPassword: "Nova Senha",
    forgotPassword: "Esqueceu a senha?",
    forgotPasswordMessage: "Entre com seu endereço de e-mail",
    enterRubk: "Entrar no Rubk",
    createAccount: "Criar conta",
    createAccountCaption: "Criar uma conta no Rubk",
    createAccountMessage:
      "Ao continuar, você está indicando que aceita nossos Termos de Serviço e Política de Privacidade.",
    socialAccountLoginMessage: "Digite seu dados abaixo.",
    /* googleLogin: 'Acesse pelo Google ou digite seus dados abaixo',
    googleLoginDino: 'Fazer login com Google', */
    linkedInLogin: "Fazer login com LinkedIn",
    facebookLogin: "Fazer login com Facebook",
    dontHaveAnAccount: "Não possui uma conta?",
    alreadyHaveAnAccount: "Já possui uma conta?",
    startNow: "COMECE AGORA",
    goToLogin: "FAZER LOGIN",
    emailConfirmation1:
      "Quase pronto! Enviamos uma confirmação para o seu e-mail.",
    emailConfirmation2: "Basta clicar no link enviado para validá-lo.",
    continue: "Acesse o Rubk para continuar:",
  },
  menu: {
    development: "Meus Projetos",
    templates: "Templates",
    rateLibrary: "Bancos de Composição",
    learning: "Aprendizado e Suporte",
    account: {
      view: "Ver perfil",
      leave: "Sair",
    },
  },
  updateCompositions: {
    loading: "Carregando",
    details: "Detalhes",
    status: "Status",
    code: "Código",
    alternativeCode: "Cód Alternativo",
    resourceGroup: "Grupo de insumo",
    description: "Descrição",
    unity: "Unidade",
    price: "Custo (R$)",
    quantity: "Quant.",
    unitCost: "Custo Unit.(R$)",
    newCost: "Novo Custo (R$)",
    totalCost: "Custo Total (R$)",
    newComposition: "Nova composição",
    currentComposition: "Composição atual",
    emptyComposition: "Composição Vazia",
    return: "Voltar",
    checkingProject: "Verificando composições do projeto",
    updatingProject: "Atualizando composições do projeto",
    changeDescription: "Substituir descrições das composições na EAP",
  },
  noresults: {
    ratelibrary: "banco de composição",
    library: "banco",
    project: "projeto",
    noexisting: "Nenhum ",
    message: " existente, vamos começar?",
    createnew: "Crie um novo ",
    click: " clicando no botão + no topo",
  },
  developments: {
    templates: "Templates",
    compositionsDatabase: "Banco de Composição",
    suportAndLearning: "Aprendizado e Suporte",
    developmentNotSelected: "Projeto não selecionado.",
    shareDevelopment: "Compartilhar Projeto",
    developmentSharedWithMe: "Projeto compartilhado comigo",
    view: "VER PROJETO",
    choose: "USAR PROJETO",
    loading: "Carregando projetos",
    loadingUpdateWbs:
      "Por favor aguarde... Estamos otimizando a performance do seu projeto...",
    name: "Nome do Projeto",
    removeAccess: "Remover acesso",
    removeAccessAlert: {
      title: "Remover projeto compartilhado?",
      content:
        "Este projeto será removido do seu acesso, apenas o autor do projeto poderá compartilhá-lo novamente com seu acesso.",
      confirm: "Remover meu acesso",
    },
    header: {
      all: "Todos",
      favorites: "Favoritos",
      search: "Procurar",
      searchDialog: "Procurar Projeto",
    },
    delete: {
      title: "Confirmar exclusão?",
      content:
        "Este projeto será excluído permanentemente e ficará indisponível para os membros que o compartilham. Esta ação não poderá ser desfeita.",
      confirm: "Excluir para sempre",
    },
    layerAdd: {
      new: "Novo Projeto",
      edit: "Editar Projeto",
      title: "CRIE UM NOVO PROJETO",
      editAdrress: "EDITAR ENDEREÇO DO PROJETO",
      placeholder: "Adicione um nome para o projeto",
      placeholderAddress: "Endereço da obra",
      start: "Iniciar",
      save: "Salvar",
      addTitle: "Adicionar novo projeto",
      useExisting: "Usar projeto existente",
      createBlank: "Criar em branco",
      chooseProject: "Escolha o projeto",
      noProjects: "Você não possui nenhum projeto!",
      creatingProject: "Criando projeto...",
    },
    noUsersFound: {
      title: "Nenhum usuário cadastrado.",
    },
    noResultsFound: {
      title: "Nenhum resultado encontrado. ",
      subtitle:
        "Tente ajustar sua pesquisa para encontrar o que você está procurando.",
    },
    form: {
      title: "Projetos",
      name: "Nome",
      image: "Imagem",
      favorite: "Favorito",
    },
    exceptions: {
      filetobig500k:
        "Arquivo muito grande. Permitido arquivos menores que 500k.",
      favoriteException: "Erro ao marcar o projeto como favorito.",
    },
  },
  rateLibraries: {
    view: "VER BANCO",
    name: "Nome do Banco",
    editLocation: "Editar localização",
    shareLibraries: "Compartilhar banco de composição",
    browser: "Navegador",
    resources: "Composições",
    loading: "Carregando bancos de composição",
    RateLibrarySharedWithMe: "Banco compartilhado comigo",
    tasks: "Insumos",
    layerAdd: {
      new: "Novo Banco de Composição",
      title: "CRIE UM NOVO BANCO DE COMPOSIÇÃO",
      namePlaceholder: "Adicione um nome para o banco",
      descriptionPlaceholder: "Adicione uma descrição (opcional)",
      locationPlaceholder: "Selecione locais de abrangência",
      sharePlaceholder: "Insira endereços de e-mail ",
      addTitle: "Adicionar novo banco",
      importSpreadsheet: "Importar Existente...",
      spreadsheetExemple: "Baixe aqui uma planilha de exemplo",
      spreadsheetTutorial: "Saiba mais como importar bancos",
      fileType: "Tipo de arquivo aceito: Excel",
      soon: "EM BREVE",
      createBlank: "Criar em branco",
      supportFileType: "Tipo de arquivo não suportado, somente xls e xlsx",
    },
    dashHeader: {
      mine: "Meus Bancos",
      public: "Bancos Públicos",
      search: "Procurar",
    },
    delete: {
      title: "Confirmar exclusão?",
      content:
        "Este banco de composição será excluído permanentemente e ficará indisponível para os membros que o utilizam. Esta ação não poderá ser desfeita.",
      confirm: "Excluir para sempre",
    },
    error: {
      message: "ERRO",
      title: "Erro ao processar os dados",
      multipleTabs: "A planilha importada possui mais de uma aba.",
      tryAgain: "TENTAR NOVAMENTE",
      cancel: "CANCELAR",
      emailNotFound: "E-mail não encontrado",
      emailsOwner: "Não é possível compartilhar um banco com você mesmo",
      emailAlreadyAdded: "E-mail já adicionado",
    },
    card: {
      import: "Importar planilha...",
    },
    cardProcessing: {
      by: "Por",
      waiting: "Aguardando processamento",
      importing: "Importando",
      processing: "Processando",
      errorMessage:
        "Houve um erro ao incluir as informações no banco de composição. Revise as informações e o arquivo e tente novamente.",
    },
    header: {
      code: "Código",
      description: "Descrição",
      unity: "Unidade",
      alternativeCode: "Cód. Alternativo",
      price: "Custo (R$)",
      quantity: "Quant.",
      unitCost: "Custo Unit.(R$)",
      totalCost: "Custo Total",
    },
  },
  contributors: {
    addContributors: "Cadastrar colaborador",
  },
  profile: {
    name: "Nome",
    email: "E-Mail",
    password: "Alterar Senha",
    registerPassword: "Cadastrar Login/Senha",
    options: {
      file: "selecionar arquivo",
      facebook: "importar do facebook",
      google: "importar do google",
    },
    tab: {
      myProfile: "Meu Perfil",
      company: "Empresa",
      contributors: "Colaboradores",
    },
    emailVerification: {
      notVerified: "E-mail não verificado",
      sendAgain: "Enviar verificação novamente",
    },
    contributors: {
      loading: "Carregando usuários",
      access: "Acesso",
      name: "Nome",
      actived: "Ativado",
      active: "Ativar",
      inactive: "Inativar",
      inactivated: "Inativado",
      delete: "Excluir",
      administrator: "Administrador",
      operator: "Operador",
      createContributor: "Cadastrar colaborador",
    },
    link: {
      google: "Vinculado ao Google",
      facebook: "Vinculado ao Facebook",
    },
    modalLinkCredencial: {
      title: "Cadastrar login e senha",
    },
    settings: "Ver configurações de perfil",
  },
  company: {
    companyName: "Nome da Empresa",
    placeholder: "Adicione o nome da empresa",
    companyLogo: "Logo da Empresa",
    chooseFile: "Selecione o arquivo",
    changeImage: "Alterar Imagem",
    saveCompany: "As informações de sua empresa foram atualizadas com sucesso",
    removeLogo: "A logo de sua empresa foi removida com sucesso",
  },
  library: {
    title: "BIBLIOTECA",
    active: "Ativo",
    upload: "Enviar",
    send: "enviar",
    uploadFile: "Carregar Arquivo",
    // onlyTypeDialogFile: "Somente tipos como ifc e ifczip.",
    onlyTypeDialogFile: "Somente tipos como ifc.",
    chooseFile: "Selecione o arquivo.",
    enabled: "Disponível",
    disabled: "Indisponível",
    status: {
      pending: "Pendente",
      processing: "Processando",
      completed: "Processado",
      error: "Erro",
    },
    tabTitle: "Navegador",
    tabTitle3D: "Navegador 3D",
    empty: {
      title: "A Biblioteca está vazia.",
      subtitle1:
        "Clique no botão Enviar para carregar arquivos IFC ou arraste e solte os arquivos necessários para adicioná-los na biblioteca.",
      subtitle2: "Arraste e solte aqui os arquivos IFC.",
    },
    loading: {
      title: "Carregando arquivos...",
      subtitle1: "Aguarde um momento, por favor.",
    },
    message: {
      IFCNotSelected: "IFC não selecionado.",
      cancelUpload: "Upload cancelado",
      errorUpload:
        "Ocorreu um erro ao enviar o seu arquivo, por favor tente novamente.",
      errorUploadFormat: "Só são permitidos arquivos com extensão .IFC.",
      // errorUploadFormat:
      //   "Só são permitidos arquivos com extensão .IFC ou .IFCZIP.",
      errorNotXeokitProject:
        "Para utilizar o visualizador de modelos atualizado é necessário excluir e adicionar novamente seus arquivos, ou então utilize a opção para “Criar novo a partir desse” na sua lista de projetos cadastrados e importe os modelos necessários",
      errorImageFormat:
        "Só são permitidos arquivos com extensão .jpg|.gif|.png.",
      errorEnableFile: "Erro ao habilitar/desabilitar o arquivo.",
      errorEnableRenderFile:
        "Erro ao habilitar/desabilitar o render do arquivo.",
      errorChangeStatus: "Erro ao alterar o status do arquivo.",
      errorDeleteFile1:
        "Arquivo não pode ser apagado, existe ModelMaps utilizando este Arquivo: ",
      erroADeleteFile2:
        "Exclua-os manualmente e tente excluir o arquivo novamente.",
      active3D: "Modelo 3D ativado para este plano de custo.",
      disactive3D: "Modelo 3D desativado para este plano de custo",
      noIFCforRender: "Não há modelos 3D para renderizar.",
      noIFCforRenderSub:
        "Envie e/ou ative um Modelo 3D no painel Biblioteca para visualizar",
      duplicateIFC: "Arquivo/IFC já existente",
    },
    delete: {
      title: "Confirmar exclusão?",
      content:
        "Este arquivo .ifc será excluído permanentemente. Esta ação não poderá ser desfeita.",
      confirm: "Excluir para sempre",
    },
  },
  costplan: {
    costPlanTitle: "Planos de custo",
    createNew: "Criar novo",
    export: {
      titleprocessing: "Realizando a geração do arquivo, por favor aguarde...",
      titleprocessed: "Processo finalizado.",
      processing: "Processando...",
      download: "Download",
    },
    duplicateCostPlan: "Duplicar plano de custo",
    costPlanName: "Nome do plano de custo",
    newCostPlanNameBlank: "Novo plano de custo em branco",
    costPlanDescription: "Descrição do plano de custo (opcional)",
    cancel: "Cancelar",
    save: "Salvar",
    delete: "Excluir",
    alertDeleteCostPlan:
      "Este processo vai excluir o plano de custo e todo seu conteúdo.",
    unavailableAction: "Ação indisponível",
    warningOneCostPlan: "Você deve ter ao menos um plano de custo no projeto.",
    acceptWarning: "Entendi",
    nameWbsAlreadyExists: "Já existe um plano de custo com esse nome",
  },

  project: {
    leftSideMenu: {
      navigator: "Navegador",
      library: "Biblioteca",
      costPlan: "Plano de Custo",
      viewer: "Visualizador 3D",
    },
    rightSideMenu: {
      properties: "PROPRIEDADES",
      code: "Código",
      formula: "Fórmula de Quantidade",
      type: "Tipo",
      origin: "Origem do Custo",
      costOrigin: {
        database: "Banco",
        scope: "Abrangência",
        additionalInformation: "Informações Adicionais",
        composition: "Composição",
        resource: "Insumo",
      },
      occurencesInBudget: "Ocorrências no orçamento",
      viewOccurrences: "Visualizar Ocorrências",
      viewer3d: "Vizualizador 3D",
      takeOffDescription: "Descrição no Take Off",
      takeOffPath: "Origem da Quantidade",
      takeOffPathNotFound: "Model Map não encontrado",
      takeOffRemoveSource: "Remover Vínculo",
      composition: "Composições de valores",
      categories: {
        labor: "Mão de Obra",
        material: "Material",
        equipment: "Equipamento",
        task: "Composição",
        other: "Outro",
        1: "Mão de Obra",
        2: "Material",
        3: "Equipamento",
        4: "Composição",
        5: "Outro",
      },
      stage: {
        title: "Não há propriedades.",
        subtitle:
          "Este elemento não contém informações adicionais para serem exibidas.",
      },
      wbs: {
        title: "Casas Decimais",
        unitCost: "Custo Unitário",
        roundingRule: {
          title: "Regra de Arredondamento",
          round: "Arredondar",
          trunc: "Truncar",
          eapTab: "EAP",
          insumoTab: "INSUMOS",
        },
        recalculate: "Recalcular",
      },
      thisWBS: "Este plano de custo",
      WBSInfo: {
        monthBase: "Mês Base",
        monthRelease: "Prazo da Obra",
        monthReleaseFocus: "Prazo da Obra (mês)",
        landArea: "Área do Terreno",
        landAreaFocus: "Área do Terreno (m²)",
        privateUnits: "Unidades Privativas",
        privateUnitsFocus: "Unidades Privativas (un)",
        builtArea: "Área Construída",
        builtAreaFocus: "Área Construída (m²)",
        equivalentArea: "Área Equivalente",
        equivalentAreaFocus: "Área Equivalente (m²)",
        privateArea: "Área Privativa",
        privateAreaFocus: "Área Privativa (m²)",
        messageMonth: "Digite apenas números",
        messageInput: "Digite apenas números e separadores (. ou ,)",
      },
      bdi: {
        title: "Preço de Venda",
        showInEap: "Exibir BDI na EAP",
        percentual: "BDI (%)",
      },
      customProperties: {
        title: "Propriedades Personalizadas",
        editProperties: "Editar propriedades",
        addProperty: "Nova Propriedade",
        deleteModal: {
          title: "Excluir propriedade?",
          text: "Este processo vai excluir a propriedade selecionada e seu conteúdo em todas as linhas.",
          buttonConfirm: "Excluir para Sempre",
        },
      },
    },
    table: {
      newResource: "Insumo sem título",
    },
    searchField: {
      resources: "Insumos",
      tasks: "Composições",
      line: "Linha",
      placeholder: "Digite um termo para buscar",
    },
  },
  syntheticReport: {
    reportTitle1: "RELATÓRIO ",
    reportTitle2: " RUBK",
    groupedResourcesSynthetic:
      "RELATÓRIO SINTÉTICO DE INSUMOS RUBK - AGRUPADO - (GRUPO DE INSUMOS)",
    groupedResourcesAnalytical:
      "RELATÓRIO ANALÍTICO DE INSUMOS RUBK - AGRUPADO - (GRUPO DE INSUMOS)",
    address: "Endereço",
    baseMonth: "Mês Base",
    monthRelease: "Prazo da Obra",
    areaCost: "CUSTO POR ÁREA (R$/m²)",
    totalCost: "CUSTO TOTAL (R$)",
    landArea: "Área do Terreno (m²)",
    privateUnits: "Unidades Privativas",
    builtArea: "Área Construída (m²)",
    equivalentArea: "Área Equivalente (m²)",
    privateArea: "Área Privativa (m²)",
    structuredCode: "Cód. Estruturado",
    font: "Fonte",
    code: "Código",
    description: "Descrição",
    quantity: "Coeficiente",
    serviceQuantity: "Quantidade",
    priceLabor: "Custo M. O.",
    priceMat: "Custo Mat",
    priceOther: "Custo Outros",
    unity: "Unid.",
    serviceCost: "Custo Unitário",
    total: "Custo Total",
    totalBdi: "Total Bdi",
    precoVenda: "Preço de Venda",
    precoTotal: "Preço Total",
    bdiPercent: "BDI (%)",
    budgetAnalytical: "Analítico de ",
    budgetSynthetic: "Sintético de ",
    budget: "Orçamento",
    resources: "de Insumos",
    takeoff: "de Itens do Take Off",
    formating: "de Formatação",
    curveABC: "Serviços",
  },
  icons: {
    cut: "Recortar",
    copy: "Copiar",
    replicate: "Replicar",
    paste: "Colar",
    insertRowBelow: "Inserir linha abaixo",
    insertRowAbove: "Inserir linha acima",
    formula: "Fórmula",
    delete: "Excluir",
    separate: "Separar itens",
    agroup: "Agrupar itens",
    moveup: "Mover para cima",
    movedown: "Mover para baixo",
    undo: "Desfazer",
    search: "Procurar",
  },
  modelMaps: {
    modalExcludeFormula: {
      title: "Excluir fórmula e substituir quantidade?",
      text_01:
        "Identificamos uma fórmula de quantidade nesta linha, ao selecionar",
      text_02: " substituir,",
      text_03: " a fórmula será apagada e o valor será substituído",
      cancel: "Cancelar",
      exclude: "Excluir e Substituir",
    },
    menuLateral: {
      modelMaps: "3D BIM MODEL MAPS",
      add: "Incluir no plano de custo",
      duplicate: "Duplicar Model Map",
      quantities: "QUANTITATIVOS",
      copy: " - Cópia",
      newModel: "criar novo",
      noModels: "Nenhum Model Map disponível.",
      noModelsSubtitle:
        "Clique no botão CRIAR NOVO para criar um novo Model Map.",
      noModelSearch: "Nenhum resultado encontrado.",
      noModelSearchSubtitle:
        "Tente ajustar sua pesquisa para encontrar o que você está procurando.",
      noFormatDefined: "Este Model Map não possui formatação definida.",
      noFormatDefined2: " Edite-o antes de adicionar ao plano de custo.",
      category: "Categoria",
      model3d: "Modelo 3D",
      filter: "Filtro",
      properties: "Propriedades",
      libraryUpdated:
        "Os modelos 3D disponíveis na biblioteca foram atualizados.",
      libraryUpdated2:
        "Verifique as alterações necessárias em seus Model Maps.",
      noModel3d: "É necessário incluir um modelo 3D na biblioteca",
      noModel3d2error: "para efetuar as correções necessárias no model map.",
      noModel3d2: "para editar o model map.",
    },
    addLayer: {
      noFileToAddLayer:
        "Não há nenhum modelo 3D ativo para esse plano de custo.",
      enableFileToAddLayer:
        "Acesse o painel Biblioteca, importe e/ou ative um modelo neste plano de custo para criar um novo Model Map.",
      modelName: "Adicione um nome para o Model Map",
      models: "MODELOS 3D",
      modelsFiltered: "MODELOS 3D FILTRADOS",
      useAllModels: "USAR TODOS MODELOS 3D",
      filterModels: "FILTRAR MODELOS 3D",
      modelIFC: "Selecione um ou mais modelos 3D",
      modelCategories: "Selecione ou digite uma categoria",
      allModels: "Todos modelos 3D aplicados a esse model map",
      headerECView: "MODEL MAP DE ELEMENTOS CONSTRUTIVOS",
      headerEC: "CRIE UM NOVO MODEL MAP DE ELEMENTOS CONSTRUTIVOS",
      headerMatView: "MODEL MAP DE MATERIAIS",
      headerMat: "CRIE UM NOVO MODEL MAP DE MATERIAIS",
      constructiveElements: "Elementos Construtivos",
      Materials: "Materiais",
    },
    takeOffLayer: {
      description: "Descrição",
      quantity: "Quantidade",
      unit: "Unidade",
      formulaWithNoQuantity:
        "A fórmula definida não gerou quantitativo maior do que zero",
      saveFormat: "Aplicar formatação no Take Off",
      editFormat: "Editar formatação do Take Off",
      errorSelect: "Existem erros que precisam ser corrigidos!",
      addField: "INSERIR CAMPO",
      searchField: "Buscar por campo",
    },
    description: {
      buildingElements: "Elementos Construtivos",
    },
    filter: {
      operators: {
        and: "e",
        or: "ou",
      },
      operations: {
        equal: "Igual",
        lessThan: "Menor que",
        greaterThan: "Maior que",
        contains: "Contém",
        notcontains: "Não contém",
        blank: "Em branco",
        filled: "Preenchido",
      },
    },
    delete: {
      title: "Confirmar exclusão?",
      content: "Os quantitativos incluídos no orçamento serão mantidos.",
    },
    removeLink: {
      title: "Remover vínculo do quantitativo?",
      content1: "Este item do plano de custo está vinculado ao model map ",
      content2:
        ". Após remover o vínculo a quantidade não será alterada em atualizações desse model map.",
    },
  },
  resources: {
    description: "Descrição",
    quantity: "Quantidade",
    unity: "Unidade",
    unitCost: "Custo Unit. (R$)",
    newCost: "Novo Custo (R$)",
    total: "Total (R$)",
    classification: "Classificação",
    origin: "Origem",
    percentage: "Porcentagem",
    cumulativePercentage: "Porcentagem Acumulada",
    cumulativePercentageSmall: "% Acum.",
  },
  wbs: {
    calculating: {
      title: "Recalculando valores",
      subtitle: "Por favor aguarde",
      tooltip: "Clique para efetuar o recálculo.",
      modal: {
        title: "Recalcular o plano de custo?",
        subtitle:
          "É necessário recalcular este plano de custo pois houveram alterações que afetam os totais. Dependendo do volume de dados do plano de custo, este recálculo poderá levar alguns minutos.",
      },
    },
    error: {
      columnNotFound: "Coluna não encontrada: ",
      updateBudgetResources:
        "Ocorreu um erro ao atualizar os insumos do orçamento!",
    },
    itemOccurrences: {
      title: "Ocorrências do item na EAP",
      loadingMessage: "Carregando pré visualização das ocorrências...",
      equipment: "Equipamento",
      labor: "Mão de obra",
      material: "Material",
      others: "Outros",
      return: "Voltar",
      fields: {
        treeCode: "Cód. EAP",
        description: "Descrição",
        quantity: "Quant.",
        unit: "Unidade",
        unitCost: "Custo Unit.",
        total: "Total",
        totalUnit: "Total Unitário",
        percentual: "%",
      },
    },
    loading: "Carregando plano de custo...",
    preparing: "Preparando...",
    processing: "Processando",
    principal: "Principal",
    blank: "Em branco",
    fromSpreadsheet: "Importar de uma planilha",
    createCopy: "Criar uma cópia a partir do atual",
    overlapData: "Sobrepor os dados existentes?",
    exportxlsx: "Exportar EAP para Excel (padrão Mega)",
    exportByGroupxlsx: "Exportar insumos por grupo para Excel",
    exportSyntheticxlsx: "Exportar relatório sintético para Excel",
    exportAnalyticalxlsx: "Exportar relatório analítico para Excel",
    exportCurveABC: "Exportar curva ABC de serviços para Excel",
    exportCurveABCAnalytical:
      "Exportar curva ABC de serviços analíticos para Excel",
    exportSAPSheet: "Exportar planilha SAP",
    nameReportCurveABC: "Curva ABC de serviços",
    nameReportCurveABCAnalytical: "Curva ABC de serviços analíticos",
    totalCostReportCurveABC: "Custo total de serviços",
    exportTakeOffxlsx: "Exportar take off do model map para Excel",
    exportFormatxlsx: "Exportar formatação do model map para Excel",
    exportResourcexlsx: "Exportar insumos para Excel",
    isolateInCP: "Destacar elementos orçados",
    isolateNotInCP: "Destacar elementos não orçados",
    noRowsToExport: "Não existem informações no orçamento para exportar",
    updateBudgetResources: "Atualizar insumos do orçamento",
    updateCompositions: "Atualizar composições",
    newRateLibraries: "Selecione o banco de composição",
    noNewValues:
      "Não foram encontrados insumos desse banco de composição na EAP",
    newProperty: "Nova propriedade",
    selectFile: "Selecione um arquivo para importação",
    importFile: "Importar arquivo...",
    name: "Nome",
    column: "Coluna",
    continue: "Continuar",
    import: "Importar",
    structCode: "Código Estruturado",
    alternative: "Código",
    description: "Descrição",
    resourceCode: "Código do Insumo",
    resourceQuantity: "Quantidade de Insumo",
    resourceCost: "Custo de Insumo",
    resourceCoefficient: "Coeficiente de Insumo",
    serviceQuantity: "Quantidade",
    serviceCost: "Custo de Serviço",
    unitCost: "Custo Unitário",
    unit: "Unidade",
    total: "Total",
    associateColumn:
      "ASSOCIE AS COLUNAS DO ARQUIVO COM AS COLUNAS DO ORÇAMENTO",
    createProperties: "CRIE PROPRIEDADES PERSONALIZADAS PARA SEU ORÇAMENTO",
    importSettings: "Configurações de importação",
    totalcost: "Custo Total",
    totalsales: "Total de Venda",
  },
  viewer: {
    isolateFromTakeOff: { isolate: "Destacar", items: "itens" },
    noFilesToRenderItems:
      "Envie e/ou ative o modelo 3D de origem dos itens no painel Biblioteca para destacar.",
    clickEvent: "Evento do Clique",
    isolateElement: "Destacar Elementos",
    toolbar: {
      restore: "Restaurar",
      similar: "Selecionar Similares",
      isolate: "Isolar Seleção",
      highlight: "Destacar Seleção",
      makeVisible: "Tornar Visível",
      makeUnvisible: "Tornar Invisível",
      fade: "Normal/Esmaecer",
      cut: "Corte",
      search: "Buscar",
      panMode: "Modo Pan",
      ruler: "Régua",
    },
    properties: {
      multipleSelection: " elementos selecionados",
      singleSelection: " elemento selecionado",
      noProperties: "Não há propriedades.",
      noInfos1: "Não há informações adicionais",
      noInfos2: "para serem exibidas",
    },
    action: {
      label: "Ação",
      hide: "Esconder",
      paint: "Pintar",
      glass: "Vidro",
      original: "Original",
      info: "Informações",
    },
    agroup: {
      label: "Agrupar por",
      element: "Elemento",
      type: "Tipo",
    },
    apply: {
      label: "Aplicar",
      selected: "No Selecionado",
      remaining: "Nos Restantes",
    },
    clip: {
      label: "Recorte",
      action: "Ação",
      reset: "Recompor",
    },
    reset: {
      label: "Tornar todos",
      style: "Padrão",
      hide: "Visíveis",
    },
    view: {
      label: "Visualização",
      normal: "Normal",
      xray: "X-Ray",
    },
    elements: {
      label: "Elementos",
      filter: {
        label: "Filtro",
        type: "Tipo",
        guid: "GUID",
      },
    },
    message: {
      errorWBSEmpty:
        "Plano de custo não existe. Criar o plano de custo em [menu/planocusto] para poder utilizar esta funcionalidade.",
    },
    navigator: {
      title: "NAVEGADOR",
      empty: {
        title: "Nenhum modelo 3D selecionado.",
        subtitle1: "Habilite um modelo 3D ",
        subtitle2: "na aba Biblioteca.",
      },
      loading: {
        title: "Carregando os modelos 3D...",
        subtitle1: "Aguarde um momento, por favor.",
      },
    },
  },
  date: {
    ago: "atrás",
    today: "hoje",
    day: "dia",
    days: "dias",
    week: "semana",
    weeks: "semanas",
    month: "mês",
    months: "meses",
    year: "ano",
    years: "anos",
  },
  firebaseFunctions: {
    sendPasswordResetEmail: {
      "auth/too-many-requests":
        "Bloqueamos todos os pedidos deste dispositivo devido a atividade incomum. Tente mais tarde.",
      error: "Erro ao enviar e-mail, tente novamente mais tarde.",
    },
    linkWithPopup: {
      success: "Conta vinculada com sucesso.",
      "auth/credential-already-in-use":
        "Esta credencial já está associada a uma conta de usuário diferente.",
      "auth/provider-already-linked":
        "O usuário só pode ser vinculado a uma identidade para o provedor fornecido.",
      "auth/email-already-in-use":
        "O endereço de e-mail já está sendo usado por outra conta.",
      error: "Erro ao vincular sua conta, tente novamente mais tarde",
    },
    unlink: {
      success: "Conta desvinculada com sucesso.",
      error: "Erro ao desvincular sua conta, tente novamente mais tarde",
    },
    updateEmail: {
      success: "Seu email foi editado com sucesso.",
      "auth/requires-recent-login":
        "Esta operação é sensível e requer autenticação recente. Faça o login novamente antes de tentar editar o email deste usuário.",
      error: "Erro ao editar email da sua conta, tente novamente mais tarde.",
    },
    updateProfile: {
      success: "O perfil do usuário foi editado com sucesso.",
      error: "Erro ao editar perfil, tente novamente mais tarde.",
    },
    linkWithCredential: {
      success: "Seu email foi vinculado com sucesso.",
      "auth/requires-recent-login":
        "Esta operação é sensível e requer autenticação recente. Faça o login novamente antes de tentar vincular o email neste usuário.",
      error: "Erro ao vincular email na sua conta, tente novamente mais tarde.",
    },
    sendEmailVerification: {
      success: "O email de verificação foi enviado com sucesso.",
      error: "Erro ao enviar email de verificação, tente novamente mais tarde.",
    },
  },
  ifc: {
    // O campo deve ter o mesmo nome do IFC no projeto
    IfcAirTerminal: "Terminal de ar",
    IfcAlarmType: "Dispositivo de alarme de incêndio",
    IfcAnnotation: "Anotação",
    IfcAssembly: "Viga estrutural",
    IfcBuildingElementPart: "Peça genérica",
    IfcBuildingElementProxy: "Elemento genérico",
    IfcBuildingStorey: "Nível",
    // IfcCableCarrierFitting: '',
    // IfcCableCarrierFittingType: '',
    IfcCableCarrierSegment: "Conexão de conduíte",
    IfcColumn: "Coluna",
    IfcCovering: "Forro",
    IfcCurtainWall: "Parede",
    IfcDoor: "Porta",
    IfcDuctFitting: "Conexão de duto",
    IfcDuctSegment: "Duto",
    IfcElectricApplianceType: "Dispositivo de dados/telefonia",
    IfcElementAssembly: "Montagem",
    IfcFireSuppressionTerminalType: "Terminal de fogo",
    IfcFlowTerminal: "Peça hidrossanitária",
    IfcFurniture: "Mobiliário",
    IfcGroup: "Grupo",
    IfcLightFixtureType: "Luminária",
    IfcMechanicalFastener: "Parafuso",
    IfcOpening: "Abertura",
    IfcOpeningElement: "Abertura",
    IfcPipeFitting: "Conexão de tubo",
    IfcPipeSegment: "Tubulação",
    IfcPlate: "Armadura",
    IfcRailing: "Guarda-corpo",
    IfcRamp: "Rampa",
    IfcReinforcementMesh: "Armadura da tela soldada",
    IfcReinforcingBar: "Armadura estrutural",
    IfcReinforcingMesh: "Vergalhão estrutural",
    IfcRoof: "Telhado",
    IfcSite: "Terreno",
    IfcSlab: "Piso",
    IfcSpace: "Ambiente",
    IfcStair: "Escada",
    // IfcSwitchingDeviceType: '',
    IfcSystemFurnitureElement: "Mobiliário",
    IfcValveType: "Acessório de tubo",
    IfcWall: "Parede",
    IfcWindow: "Janela",
    IfcZone: "Zonas AVAC",
  },
  exportByGroup: {
    title: "Exportar insumos agrupados",
    syntheticExport: "Exportação sintética",
    analyticalExport: "Exportação analitica",
    chooseProperty: "Escolha qual propriedade deseja agrupar seu relatório.",
    selctLineText: "Selected lines for replication",
    inputPlaceholder: "Search Line",
    notResultBox: {
      noResultes: "No results at the moment.",
      trySearching: "Try searching for some EAP task.",
    },
  },
  replicate: {
    title: "Replicar Informações",
    selctLineText: "Linhas selecionadas para replicação",
    inputPlaceholder: "Procurar Linha",
    notResultBox: {
      noResultes: "Nenhum resultado no momento.",
      trySearching: "Tente fazer uma busca de alguma tarefa da EAP.",
    },
  },
  unlinkCompositionDialog: {
    title: "Remover vínculo?",
    body: `Ao confirmar esta operação, a linha selecionada não terá mais vínculo com outras linhas da EAP, 
    alterações posteriores em suas informações não serão mais replicadas para as demais linhas previamente 
    vinculadas. Deseja continuar?`,
    cancel: "Cancelar",
    confirm: "Remover Vínculo",
  },
};



// WEBPACK FOOTER //
// ./src/locales/pt-BR.ts